export default __webpack_public_path__ + "static/santa-3-176e57c2edc74440fad1483b9689da8d.svg";